import styles from './keybind-row.module.css'

interface KeybindRowProps {
  readonly label: string
  readonly binding: string
  readonly capturing: boolean
  readonly prompt: string
  readonly error: string | null
  readonly moved: string | null
  readonly onActivate: () => void
}

/** One rebindable action. Activating it captures the next key or mouse button. */
export function KeybindRow({
  label,
  binding,
  capturing,
  prompt,
  error,
  moved,
  onActivate,
}: KeybindRowProps) {
  return (
    <div class={styles.row}>
      <span class={styles.label}>{label}</span>
      <div class={styles.control}>
        <button type="button" class={styles.key} onClick={onActivate}>
          {capturing ? prompt : binding}
        </button>
        {error !== null && <p class={styles.error}>{error}</p>}
        {moved !== null && <p class={styles.moved}>{moved}</p>}
      </div>
    </div>
  )
}
